import { Button, Dialog, Stack, Typography } from "@mui/material";
import { Backdrop } from "@mui/material";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { OrgPathDropdownTextField } from "../fields/OrgPathDropdownTextField";
import { LabelTextField } from "../fields/LabelTextField";
import { useAPI } from "../../hooks";
import { useToast } from "../../context";

export const EditOrganisationAlert = (props) => {
  const { open, onClose, organisationsList, selectedOrganisation, onConfirm } =
    props;

  const { api, urls, isLoading } = useAPI();
  const { showToast } = useToast();

  const [menuItems, setMenuItems] = useState([]);
  const [formData, setFormData] = useState({
    name: selectedOrganisation.name,
    code: String(selectedOrganisation.code),
    errors: {
      name: false,
      code: false,
      code_message: "",
    },
  });

  const handleSaveData = () => {
    console.log("🚀 ~ handleSaveData ~ formData:", formData);
    let invalid = false;

    if (!formData.name) {
      setFormData((prev) => {
        const curr = { ...prev };
        prev.errors.name = true;
        return curr;
      });
      invalid = true;
    }

    if (!formData.code) {
      setFormData((prev) => {
        const curr = { ...prev };
        prev.errors.code = true;
        prev.errors.code_message = "Please enter the organisation code";
        return curr;
      });
      invalid = true;
    } else if (
      organisationsList.some(
        (item) =>
          item.uuid !== selectedOrganisation.uuid && item.code === formData.code
      )
    ) {
      setFormData((prev) => {
        const curr = { ...prev };
        prev.errors.code = true;
        prev.errors.code_message =
          "Code is already taken, please use another code";
        return curr;
      });
      invalid = true;
    } else if (formData.code.length !== 4) {
      setFormData((prev) => {
        const curr = { ...prev };
        prev.errors.code = true;
        prev.errors.code_message = "Code should contain 4 digits";
        return curr;
      });
      invalid = true;
    }
    if (!invalid) {
      const params = { ...formData };
      delete params.errors;

      api
        .put(`${urls.editOrganisation}${selectedOrganisation.uuid}`, params)
        .then((res) => {
          let data = res.data;
          showToast("Organisation updated successfully", "success");
          setFormData({
            name: "",
            code: "",
            errors: {
              name: false,
              code: false,
              code_message: "",
            },
          });
          onConfirm(data.data);
        })
        .catch((err) => {
          showToast(err.response?.data?.message, "error");
        });
    }
  };

  const handleClose = () => {
    setFormData({
      code: "",
      name: "",
      errors: { name: false, code: false, code_message: "" },
    });
    onClose();
  };

  const updateFormData = (key, value) => {
    setFormData((prev) => {
      const curr = { ...prev };
      curr[key] = value;
      curr.errors[key] = false;
      return curr;
    });
  };

  const orgCodeUpdating = (code) => {
    const sanitizedCode = code.replace(/\D/g, "").substring(0, 4);
    updateFormData("code", sanitizedCode);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Stack
        direction={"column"}
        sx={{ width: 400, pt: 3, pl: 4, pr: 4, pb: 4, gap: 3 }}
      >
        <Typography
          variant="h1"
          sx={{
            mb: 2,
            textAlign: "center",
          }}
        >
          Edit Organisation
        </Typography>
        <LabelTextField
          label={"Organisation Name"}
          textInput={formData.name}
          onTextChange={(event) => {
            updateFormData("name", event.target.value);
          }}
          error={formData.errors.name}
          helperText={
            formData.errors.name ? "Please enter the organisation name" : null
          }
        />
        <LabelTextField
          label={"Organisation Code"}
          textInput={formData.code}
          onTextChange={(event) => {
            orgCodeUpdating(event.target.value);
          }}
          error={formData.errors.code}
          helperText={
            formData.errors.code ? formData.errors.code_message : null
          }
        />
        <LabelTextField
          label={"Organisation Path"}
          textInput={`${selectedOrganisation.path}`}
          error={formData.errors.name}
          disabled
        />
        <Button
          variant="contained"
          disableElevation
          color="theme"
          onClick={handleSaveData}
          sx={{
            height: 50,
            fontSize: 16,
            fontWeight: 700,
            borderRadius: 2,
            textTransform: "none",
          }}
          disabled={isLoading}
        >
          Update
        </Button>
      </Stack>
    </Dialog>
  );
};

EditOrganisationAlert.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};
